export default {
    data() {
        return {
            mounted: false,
            noDefaultQuery: false,
            queryTag: null,
            skipped: false,
        }
    },
    watch: {
        skipped() {
            if (this.skipped) {
                this.$message.info("已为您跳过默认查询");
            }
        },
    },
    created() {
        if (this.$route.query.noDefaultQuery) {
            this.noDefaultQuery = true;
        }
        this.queryTag = this.$route.query.queryTag;
    },
    mounted() {
        // let self = this;
        // setTimeout(() => self.mounted = true, 500);
        this.$nextTick(() => this.mounted = true);
    },
    methods: {
        setFilter({key, value}) {
            this.$_emCustomVuexMixin_setFilterAttribute(key, value);
        },
    },
}
